const theme = {
  colors: {
    primary: '#ff6b6b',
    secondary: '#748ffc',
    success: '#69db7c',
    danger: '#ff8787',
    warning: '#ffd43b',
    info: '#4dabf7',
    light: '#f8f9fa',
    dark: '#343a40',
    background: '#f8f9fa',
    text: '#212529',
    border: '#e9ecef',
    cardBg: '#ffffff',
    navBg: '#ffffff',
    footerBg: '#f1f3f5',
    highlight: '#fcc2d7',
    menuHover: '#e5dbff',
    sportsBg: '#d3f9d8',
    esportsBg: '#c5f6fa',
    casinoBg: '#fff3bf',
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    xxl: '1.5rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '1rem',
  }
};

export default theme; 